import { useTranslation } from 'react-i18next';

import * as St from './DiscountPriceCell.styles';

import { ProductType } from '~/core/enums';
import { formatPriceUnitOrFree } from '~/core/utils';

type DiscountPriceCellProps = {
  priceWithoutDiscount: number;
  discountPercentage?: number | null;
  applianceType?: ProductType;
};

const DiscountPriceCell = ({
  priceWithoutDiscount,
  discountPercentage,
  applianceType,
}: DiscountPriceCellProps) => {
  const { t } = useTranslation();

  return (
    <St.Container>
      <St.PriceCell>{formatPriceUnitOrFree(priceWithoutDiscount)}</St.PriceCell>
      <St.PercentageCell>
        {discountPercentage}
        {t('PRICE.OFF')} {applianceType}
      </St.PercentageCell>
    </St.Container>
  );
};

export default DiscountPriceCell;
